import Swiper from 'swiper';

export default class Slider {
  constructor(theme, element, options) {
    this.theme = theme;
    this.element = element;

    this.restartTimer = null;
    this.running = true;
    this.speed = options.speed !== undefined ? options.speed : 200;
    this.effect = options.animation || 'slide';
    this.slideChangeCallback = options.onSlideChange;

    this.swiper = this.configure();
  }

  stop = () => {
    if (this.element.querySelectorAll('.swiper-slide').length <= 1) {
      return;
    }
    this.swiper.autoplay.stop();
  }

  start = () => {
    if (this.element.querySelectorAll('.swiper-slide').length <= 1) {
      return;
    }
    this.swiper.autoplay.start();
  }

  isRunning = () => {
    return this.swiper.autoplay.running;
  }

  /**
   * @param {number} index
   */
  slideTo = (index, skipAnimation = false) => {
    this.swiper.slideTo(index, skipAnimation ? 0 : 200);
  }

  onSlideChange = () => {
    if (this.slideChangeCallback) {
      this.slideChangeCallback();
    }
  };

  configure = () => {
    if (this.element.querySelectorAll('.swiper-slide').length <= 1) {
      return;
    }
    const swiper = new Swiper(this.element, {
      allowTouchMove: false,
      loop: true,
      loopedSlides: this.effect === 'fade' ? 0 : 2,
      autoplay: this.speed > 0 ? {
        delay: this.speed,
        disableOnInteraction: false,
      } : false,
      effect: this.effect,
      slidesPerView: 1,
      speed: 300,
      watchOverflow: true,
      fadeEffect: { crossFade: true },
      navigation: {
        nextEl: this.element.querySelector('.flex-next'),
        prevEl: this.element.querySelector('.flex-prev'),
      },
      pagination: {
        el: this.element.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });
    swiper.on('slideChange', this.onSlideChange);
    return swiper;
  };
}
